import React from 'react';
import BackLink from './BackLink';

export default function DetailPage({ title, backTo, backLabel, meta, children }) {
  return (
    <div className="detail-page">
      <div className="detail-header">
        {backTo && <BackLink to={backTo}>{backLabel || 'Back'}</BackLink>}
        {title && <h2>{title}</h2>}
        {meta && <div className="meta-row">{meta}</div>}
      </div>
      <div className="detail-body">{children}</div>
    </div>
  );
}
